module.exports = __webpack_public_path__ + "media/V39.da6706b4.mp4";